import { Box, Divider, makeStyles } from '@material-ui/core';
import { TimelineEvent } from '@src/types';

interface IChatMessageWSFlowQuickMessage {
  message: Partial<TimelineEvent>;
}

const useStyles = makeStyles(theme => ({
  divider: {
    backgroundColor: theme.palette.grey[300],
    marginTop: '7px',
  },
}));

const ChatMessageWSFlowQuickMessage: React.FC<
  IChatMessageWSFlowQuickMessage
> = ({ message }) => {
  const { divider } = useStyles();

  return (
    <>
      <Box width="100%">
        <Box fontSize="14px" fontWeight={500} width="100%" p={1.5}>
          {message.bodyText || ''}
        </Box>
        <Divider classes={{ root: divider }} />
        <Box display="flex" textAlign="center" justifyContent="center">
          <span style={{ color: '#478ECC', marginTop: '12px' }}>
            {message.flowCta}
          </span>
        </Box>
      </Box>
    </>
  );
};

export default ChatMessageWSFlowQuickMessage;
